export default "__VITE_ASSET___CId$rWw__"